
import { useQuery } from '@tanstack/react-query';
import { familyMembershipService } from '@/services/family';
import { FamilyMember } from '@/types/database';
import { FAMILY_MEMBERS, getEntityKey } from '@/constants/queryKeys';

/**
 * Hook to fetch and cache family members
 */
export const useFamilyMembers = (userId: string | null | undefined) => {
  const {
    data: familyMembers = [],
    isLoading,
    error
  } = useQuery({
    queryKey: getEntityKey(FAMILY_MEMBERS, userId),
    queryFn: async () => {
      if (!userId) return [];
      return familyMembershipService.getFamilyMembers(userId);
    },
    enabled: !!userId,
    staleTime: 3 * 60 * 1000, // 3 minutes
  });
  
  const isSingleMemberFamily = familyMembers.length === 1;
  
  return {
    familyMembers,
    isSingleMemberFamily,
    isLoading,
    error: error ? String(error) : null
  };
};
